import ApplicationController from '../frontend/controllers/application_controller';

export default class extends ApplicationController {
  


}